import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { useAuthStore } from '../../../../auth/shared/store/useAuthStore';
import { ConfirmationMain } from './ConfirmationMain';
import { CreateUserAccount } from './CreateUserAccount';
import { useStateValidation } from '../shared/validation/useStateValidation';
import { useBookingSubmittedValidation } from '../shared/validation/useBookingSubmittedValidation';
import { useResetBookingOnUnmount } from '../shared/reset/useResetBookingOnUnmount';

interface IConfirmationProps {
	children: ReactNode;
}

export const Confirmation = observer(({ children }: IConfirmationProps) => {
	useStateValidation([useBookingSubmittedValidation()]);

	useResetBookingOnUnmount();

	const authStore = useAuthStore();
	const canCreateUserAccount = !authStore.isAuthenticated;

	return (
		<>
			{canCreateUserAccount && <CreateUserAccount />}
			<ConfirmationMain>{children}</ConfirmationMain>
		</>
	);
});
